import { Paper, Typography } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { CSSProperties } from 'react';
import { Background, Parallax } from 'react-parallax';
const styles = {

}


const defaultRootStyle: CSSProperties = {
	height: '500px',
	paddingTop: '20px',
	textAlign: 'center'
}

const defaultInnerContentStyle: CSSProperties = {
	height: '250px',
	left: '50%',
	overflow: 'hidden',
	position: 'absolute',
	textAlign: 'center',
	top: '50%',
	transform: 'translate(-50%, 0%)'
}

const defaultBackgroundStyle: CSSProperties = {
	width: '100%'
}

interface IHeroStoryPanningProps {
	name: string;
	backgroundImage: string;
	titleImage?: string;
	backgroundVideo: string;
	innerContent: any;
	height?: number;
	fontSize?: number;
	paperWidth?: number;
	strength?: number;
	hidden?: boolean;
}

interface IComponentProps {
	parallaxParent: Node;
}


type Props = IHeroStoryPanningProps & WithStyles;

export class HeroStoryPanning extends React.Component<Props, IComponentProps> {
	static get defaultProps() {
		let width = Math.floor(window.innerWidth * 0.6);
		if (width < 768) {
			width = window.innerWidth - 20;

		}
		return {
			fontSize: (window.innerWidth < 800 ? 14 : 20),
			height: 500,
			// paperWidth: 1400,
			paperWidth: width,
			strength: 500
		}
	}
	constructor(props: Props) {
		super(props);
		this.state = {
			parallaxParent: document
		};
	}

	public componentDidMount() {
		this.setState({
			parallaxParent: document.getElementById('parallaxParent')!
		})
	}

	public render(): any {
		const { innerContent, backgroundImage, fontSize, name, height, paperWidth, backgroundVideo, titleImage, hidden } = this.props;
		const { parallaxParent } = this.state;
		return (
			<div style={{marginBottom: '25px'}} hidden={hidden}>
				<Parallax style={defaultRootStyle} bgStyle={defaultBackgroundStyle} strength={500} parent={parallaxParent}>
					<Background>
						<video width={1920} height={height} src={backgroundVideo} autoPlay={true} muted={true} loop={true} playsInline={true} style={{ width: '100%', objectFit: 'cover' }} />
					</Background>
					<div style={defaultInnerContentStyle}>
						<img src={titleImage || backgroundImage} alt={name} />
					</div>
				</Parallax>	
				<Parallax strength={500} bgImage={backgroundImage} parent={parallaxParent}>
					<Paper style={{width: `${paperWidth}px`, minHeight: `${height}px`, background: `linear-gradient(to right, rgba(11, 11, 11, .8), rgba(11, 11, 11, 1) ${paperWidth! / 2}px, rgba(11, 11, 11, .8) ${paperWidth}px)`, backgroundSize: `${paperWidth}px 100%`, backgroundPosition: '50% 100%', backgroundRepeat: 'no-repeat', overflow: 'hidden', margin: '10px auto'}}>
						<Typography color={'secondary'} align="left" component={'div'} style={{fontSize: `${fontSize}px`, position: 'relative', padding: '20px'}}>
							{innerContent}
						</Typography>
					</Paper>
				</Parallax>
			</div>
		);
	}
}

export default withStyles(styles)(HeroStoryPanning);


// WEBPACK FOOTER //
// ./src/components/HeroStoryPanning.tsx